<template>
  <div
    v-if="hasAnyEspot && !isClosed"
    id="espot-debugger"
    aria-hidden
    class="fixed bottom-0 left-0 z-toast mb-4 ml-4 overflow-auto rounded-md p-4 text-sm shadow-lg"
    style="background-color: #dcebff; max-width: 30rem; max-height: 40vh"
  >
    <div class="mb-1 flex items-start gap-2 between">
      <div>
        <p class="pb-2 fw-bold">
          E-spots
        </p>
        <p class="text-xs">
          Click to scroll to focus and highlight only that e-spot. Click again to deselect.<br>
          (e-spots listed in italics are not present in the page due to some specific conditions)
        </p>
      </div>
      <base-button
        class="b rounded p-1 text-xs"
        @click="isClosed = true"
      >
        Close
      </base-button>
    </div>
    <ul class="list-disc pl-4">
      <li
        v-for="espot in sections"
        :key="espot.name"
        :style="{ paddingLeft: '0.5rem' }"
      >
        <base-button
          class="py-1"
          :class="{ underlined: selected === espot.name, italic: !refs[espot.name] }"
          :disabled="!refs[espot.name]"
          @click="select(espot.name)"
        >
          {{ espot.displayName || espot.name }}
        </base-button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import eSpotMapping from '#core/utils/cms/eSpotsMapping.json'

const currentPageSections = useState<Record<PropertyKey, unknown>>('currentPageSections', () => ({}))
const refs = useState<Record<string, HTMLElement | null>>('sectionRefs', () => ({}))
const selected = useState<string | null>('espotSelected', () => null)
const isClosed = ref(false)

const hasAnyEspot = computed(() => Object.keys(currentPageSections.value || {}).length > 0)

const sections = computed<Array<{ name: string, displayName?: string }>>(() => {
  if (!currentPageSections.value) return []
  return Object.keys(currentPageSections.value)
    .map((name) => ({
      name,
      displayName: (eSpotMapping as any)[name] || name,
    }))
})

const select = (name: string) => {
  const el = refs.value[name] as HTMLElement | null
  if (!el) return
  if (selected.value === name) {
    selected.value = null
    return
  }
  selected.value = name
  el.scrollIntoView({ behavior: 'smooth' })
}

onBeforeUnmount(() => {
  selected.value = null
})

onBeforeRouteLeave(() => {
  currentPageSections.value = {}
  selected.value = null
})
</script>
